import { render, staticRenderFns } from "./DaftarHarga.vue?vue&type=template&id=cfcb8b3a&"
import script from "./DaftarHarga.vue?vue&type=script&lang=js&"
export * from "./DaftarHarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports